import { http } from '@/services/api.service'

export const MEDIA_INTERNAL_DOMAIN_UUID = '2bc5decc-cd2e-46ad-92d7-f17234fdeebd'
export const NOSDROITS_DOMAIN_UUID = '792a622b-fa4c-44c7-92fa-b1b0fd37336a'

export const selectInternalSourceDomain = async (store, domainUuid) => {
  const currentDomain = store.getters.domain
  if (currentDomain && currentDomain.uuid === domainUuid && currentDomain.label) {
    return currentDomain
  }

  const { data } = await http.get(`/domain/${domainUuid}`)
  store.commit('SET_DOMAIN', data)
  await store.dispatch('FETCH_ROLES')
  return data
}
